import gql from 'graphql-tag';

export const DEPRECATE_ARTICLES_MUTATION = gql`
  mutation DeprecateArticlesMutation($articleIds: [ID!]!) {
    deprecateArticles(articleIds: $articleIds) {
      articles {
        id
        deprecated
      }
      errors
    }
  }
`;
